module.exports = __webpack_public_path__ + "static/media/Affinity Group PEO Solutions Overview.f6676c62.pdf";